import { Columns } from '@domain-group/suit-theme'

import useAdAccountGroup from '@hooks/useAdAccountGroup'

import AdAccountGroupLinks from '../AdAccountGroupLinks'
import PageLayout from '../../../../components/PageLayout'

interface PageContentProps {
  adAccountGroupId: number,
}

const PageContent = (props: PageContentProps) => {
  const { adAccountGroupId } = props

  const adAccountGroupPayload = useAdAccountGroup({ id: adAccountGroupId })

  return (
    <PageLayout adAccountGroupPayload={adAccountGroupPayload} activeTabBarItemKey="relations">
      <Columns.Main>
        <AdAccountGroupLinks adAccountGroupId={adAccountGroupId} linkableType="Client" />
      </Columns.Main>
    </PageLayout>
  )
}

export default PageContent
